import React, { useState, useEffect } from 'react';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  const handleSettings = () => {
    
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Wir verwenden Cookies</h3>
          <p>
            Wir verwenden Cookies und aehnliche Technologien, um Ihnen ein besseres Nutzererlebnis zu bieten,
            die Leistung unserer Website zu analysieren und personalisierte Inhalte anzuzeigen.
            Weitere Informationen finden Sie in unserer <a href="/privacy-policy">Datenschutzerklaerung</a>.
          </p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleAccept} className="cookie-btn cookie-btn-accept">
            Alle akzeptieren
          </button>
          <button onClick={handleSettings} className="cookie-btn cookie-btn-settings">
            Einstellungen
          </button>
          <button onClick={handleDecline} className="cookie-btn cookie-btn-decline">
            Ablehnen
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;